import {Component, Input, OnInit} from '@angular/core';
import {AbstractControl, FormGroup} from '@angular/forms';
import {
  targetedPopulationAnswers,
  aspectBenefitedAnswers
} from '../../constants/funding-request-answers/system-development-question-answers.const';
import {createNumberMask} from 'text-mask-addons/dist/textMaskAddons';
import {FormValidationService} from '../../../../../../../services/form-validation/form-validation.service';
import {checkForValue} from '../../../../../../organisation/capacity-spectrum/components/capacity-spectrum/store/capacity-spectrum.model';

@Component({
  selector: 'app-system-development',
  templateUrl: './system-development.component.html',
  styleUrls: ['./system-development.component.scss']
})
export class SystemDevelopmentComponent implements OnInit {

  theme: 'dark' | 'light' = 'light';
  style: 'default' | 'bordered' = 'default';

  @Input() systemDevelopmentForm: FormGroup;
  @Input() formValid: boolean;
  @Input() isReadOnly: boolean;
  @Input() fromReview: boolean;

  targetedPopulation = targetedPopulationAnswers;
  aspectBenefited = aspectBenefitedAnswers;
  numberMask: any;

  durationOfTypeOptions = [
    {
      label: 'Days',
      value: 'Days'
    },
    {
      label: 'Months',
      value: 'Months'
    }
  ];

  constructor(public formValidationService: FormValidationService) {
  }

  ngOnInit() {
    this.numberMask = createNumberMask({
      prefix: '',
      suffix: '',
      allowDecimal: false,
      allowNegative: false,
      includeThousandsSeparator: false
    });
  }

  checkOther(value: string | boolean, selectedValue: string, controlParent: AbstractControl, controlChild: AbstractControl) {
    checkForValue(value, selectedValue, controlParent, controlChild);
  }
}
